import React, { useState } from "react";
import { Link } from "react-router-dom";

const NavMenu = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);
  const [activeSubSubDropdown, setActiveSubSubDropdown] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleDropdownMouseEnter = (i) => {
    setActiveDropdown(i);
  };

  const handleDropdownMouseLeave = () => {
    setActiveDropdown(null);
  };

  const handleSubDropdownMouseEnter = (i, j) => {
    setActiveDropdown(i);
    setActiveSubDropdown(j);
  };

  const handleSubDropdownMouseLeave = () => {
    setActiveSubDropdown(null);
  };

  const handleSubSubDropdownMouseEnter = (i, j, k) => {
    setActiveDropdown(i);
    setActiveSubDropdown(j);
    setActiveSubSubDropdown(k);
  };

  const handleSubSubDropdownMouseLeave = () => {
    setActiveSubSubDropdown(null);
  };

  const menu = [
    {
      label: "About",
      link: null,
      dropdownItems: [
        {
          label: "About Us",
          link: "/aboutus",
        },
        {
          label: "Vision and Mission",
          link: "/MissionVission",
        },
        

        {
          label: "Chancellor Message",
          link: "/message",
        },
        {
          label: "Rector Messages",
          link: "/rectormessages",
        },
        {
          label: "Registrar Message",
          link: "/",
        },
        {
          label: "Board of Governors",
          link: "/",
        },
        {
          label: "Academic Council",
          link: "/",
        },
        {
          label: "Board of Advance Studies & Research (BASR)",
          link: "/",
        },
        {
          label: "Organogram of EIMS",
          link: "/",
        },
      ],
    },
    {
      label: "Department",
      link: null,
      dropdownItems: [
        {
          label: "Business Administration",
          hasSubDropdowns: true,
          subDropdownItems: [
            {
              label: "MBA 2 years",
              link: "/Mba2years",
            },
            {
              label: "MBA 1.5 years",
              link: "/Mba1years",
            },
            {
              label: "BBA 4 years",
              link: "/BBA4YEARS",
            },
            {
              label: "BBA 2 years",
              link: "/ADPCommerce",
            },
            {
              label: "ADP Business & Commerce (2 years)",
              link: "/ADPCommerce",
            },
          ],
        },
        {
          label: "Computer Science",
          hasSubDropdowns: true,
          subDropdownItems: [
            {
              label: "BSCS (4 years)",
              link: "/BSCS4Years",
            },
            {
              label: "BSCS (2.5 years)",
              link: "/BSCS4Years",
            },
            {
              label: "ADP Web Design & Development",
              link: "/ADPWDD&D",
            },
            {
              label: "ADP Computer Networking",
              link: "/ADPNetworking",
            },
            {
              label: "ADP Database Management System",
              link: "/ADPDatabase",
            },
          ],
        },
      ],
    },
    {
      label: "Admission",
      dropdownItems: [
        {
          label: "Fee Structure",
          link: "/feestructure",
        },
        {
          label: "Eligibility",
          link: "/eligibility",
        },
        {
          label: "Scholarship",
          link: "/scholarship",
        },
        {
          label: "Admission Policy",
          link: "/admissionpolicy",
        },
      ],
    },
    {
      label: "Academics",
      link: "/",
      dropdownItems: [
        {
          label: "Semester Rules",
          link: "/",
        },
        {
          label: "Academic Calender",
          link: "/",
        },
      ],
    },
    {
      label: "QEC",
      link: "/",
      dropdownItems: [
        {
          label: "Quality criteria",
          link: "/",
        },
        {
          label: "Methodology by QEC",
          link: "/",
        },
        {
          label: "Organizational Structure",
          link: "/",
        },
        {
          label: "Accreditation",
          link: "/",
        },
        {
          label: "Achievements",
          link: "/",
        },
        {
          label: "QEC Events",
          link: "/",
        },
      ],
    },
    {
      label: "Research",
      link: "/",
      dropdownItems: [
        {
          label: "ORIC",
          link: "/oric",
          hasSubDropdowns: true,
          subDropdownItems: [
            // { label: "oric", link: "/oric" },
            {
              label: "Research Grants",

              hasSubDropdowns: true,
              subDropdownItems: [
                {
                  label:
                    "Grant for Research Fellowship Abroad National University",
                  link: "/researchgrands1",
                },
                {
                  label: "Research Publications Grant Proposal",
                  link: "/researchgrands2",
                },
                {
                  label:
                    "Faculty/ Students/ Alumni Research Grand Proposal (ERGP)",
                  link: "/researchgrands3",
                },
                {
                  label: "FIMS Conference Workshop Grant Proposal",
                  link: "/researchgrands4",
                },
              ],
            },
            {
              label: "Research Rewards",
              
              hasSubDropdowns: true,
              subDropdownItems: [
                {
                  label: "Citation Reward Program form (CRP)",
                  link: "/Citation",
                },
              ],
            },
            { label: "Research Support Program ", link: "/" },
            { label: "Faculty Research Information Form", link: "/" },
            { label: "Seminars", link: "/SeminarsandWorkshop" },
            { label: "Research Artical Regional", link: "/" },
          ],
        },
        {
          label: "Journals",
          link: "/JournalsResearch",
          hasSubDropdowns: true,
          subDropdownItems: [
            // { label: "JOURNALS", link: "/JournalsResearch" },
            { label: "Journal of Business and Science", link: "/EJMS" },
            { label: "Journal of Computer Science", link: "/" },
          ],
        },
        { label: "Conference" },
      ],
    },
    {
      label: "LMS",
      link: "/",
      dropdownItems: [
        {
          label: "Student Login",
          link: "/login",
        },
        {
          label: "Faculty Login",
          link: "/login",
        },
      ],
    },
    {
      label: "Certificate",
      link: "/",
      dropdownItems: [
        {
          label: "Mobile App Development",
          link: "/mobileappdevelopement",
        },
        {
          label: "Python course",
          link: "/pythoncourse",
        },
        {
          label: "Blockchain",
          link: "/blockchain",
        },
        {
          label: "Penetration Testing",
          link: "/penetrationtesting",
        },
        {
          label: "Ethical Hacking",
          link: "/ethicalhacking",
        },
        {
          label: "Net Developement",
          link: "/netdevelopement",
        },
      ],
    },
  ];

  return (
    <div>
      <nav className="bg-maroon w-full h-16 flex-shrink flex justify-center list-none">
        <ul className="hidden lg:flex justify-evenly w-[90%] m-auto">
          <Link to="/" className="text-white px-3 py-2">
            Home
          </Link>
          {menu.map((item, i) => (
            <li
              key={i}
              className="relative"
              onMouseEnter={() => handleDropdownMouseEnter(i)}
              onMouseLeave={handleDropdownMouseLeave}
            >
              <button className="text-white px-3 py-2">
                {item.label}
              </button>
              {activeDropdown === i && (
                <ul className="absolute bg-black opacity-90 text-white shadow rounded -mt-1 py-1 z-20 w-[200px]">
                  {item.dropdownItems.map((subItem, j) => (
                    <li
                      key={j}
                      className="relative z-20 border-b-[1px] border-white w-[90%] m-auto"
                      onMouseEnter={() => handleSubDropdownMouseEnter(i, j)}
                      onMouseLeave={handleSubDropdownMouseLeave}
                    >
                      <Link to={subItem.link}>
                        <button className="block px-4 py-2 text-sm w-full text-left hover:bg-slate-50 hover:text-black rounded-md">
                          {subItem.label}
                        </button>
                      </Link>
                      {subItem.hasSubDropdowns && activeSubDropdown === j && (
                        <ul className="absolute left-full z-20 top-0 mt-[-0.25rem] bg-black opacity-90 text-white shadow rounded py-1 w-[200px]">
                          {subItem.subDropdownItems.map((subSubItem, k) => (
                            <li
                              key={k}
                              className="relative z-20 border-b-[1px] border-white w-[90%] m-auto"
                              onMouseEnter={() => handleSubSubDropdownMouseEnter(i, j, k)}
                              onMouseLeave={handleSubSubDropdownMouseLeave}
                            >
                              <Link to={subSubItem.link}>
                                <button className="block px-4 py-2 text-sm w-full text-left hover:bg-slate-50 hover:text-black rounded-md">
                                  {subSubItem.label}
                                </button>
                              </Link>
                              {subSubItem.hasSubDropdowns && activeSubSubDropdown === k && (
                                <ul className="absolute left-full z-20 top-0 mt-[-0.25rem] bg-black opacity-90 text-white shadow rounded py-1 w-[200px]">
                                  {subSubItem.subDropdownItems.map((subSubSubItem, l) => (
                                    <li key={l}>
                                      <Link to={subSubSubItem.link}>
                                        <button className="block px-4 py-2 text-sm text-left border-b-[1px] border-white w-[90%] m-auto hover:bg-slate-50 hover:text-black">
                                          {subSubSubItem.label}
                                        </button>
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
          <Link to="/contact">
            <button className="text-white px-3 py-2">Contact</button>
          </Link>
          <Link to="/gallery">
            <button className="text-white px-3 py-2">Gallery</button>
          </Link>
        </ul>
      </nav>
    </div>
  );
};

export default NavMenu;
